<template>
  <div>
    <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
      <el-tab-pane
        v-for="tab in tabData"
        class="paymentTab"
        :key="tab.label"
        :label="tab.label"
        :name="tab.name"
      >
        <div v-if="activeName=='alipay f2f'">
          <div v-if="init">请扫描下方二维码付款</div>        
          <el-alert
            v-else
            title="请确认金额"
            style="text-align:left"
            type="info"
            :closable="false"
            description="确认后点击确定获取充值二维码"
            show-icon
          ></el-alert>
          <div v-loading="isQrLoading">
            <vue-qr v-loading="isQrLoading" :text="tab.qr" :correctLevel="3" :size="300"></vue-qr>
          </div>
        </div>
        <div v-else-if="activeName=='alipay potota'">
        <el-alert
            style="text-align:left"
            type="info"
            :closable="false"
            description="点击确定进入支付页面"
            show-icon
          ></el-alert>
        </div>
        <div v-else-if="activeName=='wechat potota'">
        <el-alert
            style="text-align:left"
            type="info"
            :closable="false"
            description="点击确定进入支付页面"
            show-icon
          ></el-alert>
        </div>
        <div v-else-if="activeName=='card'">
        <el-alert
            title="支持以下信用卡："
            style="text-align:left"
            type="warning"
            :closable="false"
            description="Visa / Mastercard / American Express / JCB / Diners Club / Discover"
            show-icon
          ></el-alert>
        <br/>
        <el-alert
            title="不支持以下信用卡："
            style="text-align:left"
            type="error"
            :closable="false"
            description="银联 Union Pay"
            show-icon
          ></el-alert>
        <br/>
        <el-alert
            title="信用卡不支持直接支付购买套餐"
            style="text-align:left"
            type="warning"
            :closable="false"
            description="可以信用卡充值余额后使用余额购买套餐"
            show-icon
          ></el-alert>
        <br/>
        <el-alert
            style="text-align:left"
            type="info"
            :closable="false"
            description="点击确定进入信用卡支付页面"
            show-icon
          ></el-alert>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import VueQr from "vue-qr";
import Axios from "axios";

export default {
  components: {
    "vue-qr": VueQr
  },
  props: ["globalConfig", "userInfo", "orderItem", "init"],
  data() {
    return {
      activeName: "alipay f2f",
      tabData: [
        {
          label: "支付宝1",
          name: "alipay f2f",
          qr: "0"
        },
        {
          label: "支付宝2",
          name: "alipay potota",
          qr: "0"
        },
        {
          label: "微信1",
          name: "wechat potota",
          qr: "0"
        },
        /*{
          label: "信用卡（赠20%余额）",
          name: "card stripe",
          qr: "0"
        }*/
      ],
      tid: "",
      isQrLoading: false
    };
  },
  watch: {
    init(val) {
      if (val) {
        this.initCharge();
      } else {
        this.tabData.forEach(item => {
          item.qr = "0";
        });
        this.isQrLoading = false;
      }
    }
  },
  mounted() {
    if (this.init) {
      console.log('a');
      this.initCharge();
    }
  },
  methods: {
    handleClick(tab, event) {
      console.log(tab, event);
    },
    initCharge() {
      this.isQrLoading = true;
      this.$notify({
        title: "正在连接支付网关",
        message: "感谢您对我们的支持，请耐心等待",
        type: "success"
      });

      let pid = 0;

      let price = parseFloat(this.orderItem[0].total);
      console.log(price);

      setTimeout(() => {
        let activeName = this.activeName.split(" ");
        let body = { price: price, type: activeName[0], gate:activeName[1]};
        Axios({
          method: "post",
          url: "/user/payment/purchase",
          data: JSON.stringify(body),
          withCredentials: true,
          headers: { "content-type": "application/json" }
        })
          .then(r => {
            console.log(r);
            if (r.data.ret === 1) {
              if(r.data.type=='qr'){
                pid = r.data.pid;
                this.isQrLoading = false;
                return r.data.qrcode;
              }else if(r.data.type=='url'){
                window.location.href = r.data.url;
              }
            } else {
              this.$message.error(r.data.msg);
            }
          })
          .then(r => {
            window.console.log(r);
            this.$notify({
              title: "支付网关连接完成",
              message: "请扫描二维码完成支付",
              type: "success"
            });
            this.tabData.forEach(item => {
              //无法判断二维码来自哪个支付方式，因此给所有支付方式都赋值二维码
              item.qr = r;
            });
            this.tid = setTimeout(() => {
              this.chargeChecker(pid);
            }, 1000);
          });
      }, 300);
    },
    chargeChecker(token) {
      let headers = {
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8"
      };
      let params = new URLSearchParams();
      params.set("pid", token);
      Axios({
        method: "post",
        url: "/payment/status",
        data: params,
        withCredentials: true,
        headers
      }).then(r => {
        if (r.data.result) {
          this.$message({
            message: "支付成功！",
            type: "success"
          });
          this.$emit("successfully-paid");
        } else {
          this.tid = setTimeout(() => {
            this.chargeChecker(token);
          }, 1000);
        }
      });
    }
  }
};
</script>

<style lang="stylus" scoped>
.paymentTab
  text-align: center
</style>
